import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse, HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs'
import { tap, catchError } from 'rxjs/operators';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    request: any;
    intercept(req: HttpRequest<any>,
        next: HttpHandler): Observable<HttpEvent<any>> {
        const idToken =localStorage.getItem("token");
        if (idToken) {
            this.request = req.clone({
                headers: req.headers.set('authorization',
                    'Bearer ' + idToken)
            });
        }
        else {
            this.request = req.clone({
                headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            });
            return next.handle(req);

        }
        return next.handle(this.request).pipe(tap((event: any) => { }, (error: any) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status == 403 || error.error.message == "Failed to authenticate token.") {
                    localStorage.removeItem('token');
                    localStorage.removeItem('name');
                    localStorage.removeItem('currentUser');
                    window.location.href = "/admin/login?messege=TokenIsExpired";
                }
            }
        }));
    }
}
